export default __webpack_public_path__ + "static/media/Marketing Circle.11c5de8c.svg";